// MinifyUtils.tsx
export const minifyCss = (css: string): string => {
    return css
      .replace(/\/\*[\s\S]*?\*\/|\/\/.*/g, '') // Remove comments
      .replace(/\s+/g, ' ') // Replace whitespace with a single space
      .replace(/\s*{\s*/g, '{') // Remove spaces around braces
      .replace(/\s*}\s*/g, '}')
      .replace(/\s*;\s*/g, ';')
      .replace(/\s*:\s*/g, ':')
      .replace(/;\}/g, '}') // Remove trailing semicolons before closing braces
      .trim();
  };
  
  export const minifyHtml = (html: string): string => {
    return html
      .replace(/<!--[\s\S]*?-->/g, '') // Remove HTML comments
      .replace(/\s+/g, ' ') // Replace multiple whitespace with single space
      .replace(/>\s+</g, '><') // Remove whitespace between tags
      .replace(/\s+>/g, '>') // Remove whitespace before closing tag
      .replace(/<\s+/g, '<') // Remove whitespace after opening tag
      .replace(/\s+\/>/g, '/>') // Remove whitespace before self-closing tag
      .trim();
  };